export default __webpack_public_path__ + "0632f3cc492043b18b4e6cb29b4c3c8c.svg";